
import { SessionController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Edit the avatar information: Picture upload, Initials + color or Gravatar.
 * @example
 * ```html
 * <salaxy-account-avatar-edit></salaxy-account-avatar-edit>
 * ```
 */
export class AccountAvatarEdit extends ComponentBase {
    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {};

    /** Uses the SessionController */
    public controller = SessionController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/account/AccountAvatarEdit.html";

}
